/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
export * from './si-translate-ngxt.module';
export * from './si-translate-ngxt.provider';
